import { render, staticRenderFns } from "./LinkConfirmDialog.vue?vue&type=template&id=8bed8f08&scoped=true&"
import script from "./LinkConfirmDialog.vue?vue&type=script&lang=js&"
export * from "./LinkConfirmDialog.vue?vue&type=script&lang=js&"
import style0 from "./LinkConfirmDialog.vue?vue&type=style&index=0&id=8bed8f08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bed8f08",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAvatar,VBtn,VDialog,VDivider,VIcon})
